import type { TBlueTable } from "@app/types/insider";
export type TAppProcess = {
  prcid: number;
  prcname: string;
};

export const appProcess: TBlueTable<TAppProcess> = {
  name: "appProcess",
  empty: {
    prcid: 0,
    prcname: "moa",
  } as TAppProcess,
  initialState: { 0: { prcid: 0, prcname: "moa" } },
  apiUrl: null,
  pkeyUrl: null,
  primaryKey: "prcid",
  starfx: true,
  idb: false,
  bootPriority: -1,
  onmru: "no",
  oncsdb: "no",
  label: "Process flow control",
  appContext: [],
};
